import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePatientMutation } from '../../api/patient/usePatientMutation';
import { FormError } from '../form/FormError';
import { TextField } from "@mui/material";
export const PatientInlineMrnForm = (props) => {
    const { onComplete, initialValue, patientId, initialEditing } = props;
    const { mutateAsync } = usePatientMutation();
    const [isEditing, setIsEditing] = useState(initialEditing);
    const { handleSubmit, register, formState: { errors }, } = useForm({
        defaultValues: {
            mrn: initialValue,
        },
    });
    const onSubmit = async (data) => {
        console.log('is submitting');
        if (data.mrn !== initialValue) {
            if (data.mrn === '') {
                data.mrn = 'null';
                await mutateAsync({ patientId, ...data });
                data.mrn = '';
            }
            else {
                await mutateAsync({ patientId, ...data });
            }
            onComplete(data.mrn);
        }
    };
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true, style: { borderRadius: '4px', border: isEditing ? '1px solid #2C78EB' : 'none', padding: isEditing ? '5px' : '0px' } },
        React.createElement("div", { className: "text-sm flex items-center", style: { height: '30px' } },
            React.createElement(TextField, { ...register('mrn'), id: "user-mrn", variant: 'standard', style: { fontSize: 11, color: 'rgba(0, 0, 0, 0.87)', fontFamily: 'Barlow', fontWeight: '400', width: '100%', verticalAlign: 'middle' }, size: 'small', onClick: () => setIsEditing(true), inputProps: { style: { height: '10px', fontSize: 12 } }, placeholder: 'i.e. 123456', InputProps: {
                    disableUnderline: true,
                }, onBlur: (e) => {
                    const currentValue = e.target.value;
                    setIsEditing(false);
                    if (currentValue !== initialValue) {
                        handleSubmit(onSubmit)();
                    }
                    else {
                        props.onCancel();
                    }
                } })),
        React.createElement(FormError, { errors: errors, name: "mrn", className: "font-bold text-app-red-dark block text-sm mt-1" })));
};
